// extracted by mini-css-extract-plugin
export default {"overflow":"NoiNmO","row":"iP9HsX","total":"lOOlSc","nameContainer":"EmHeDi"};